import "./PoolSelect.scss"
import React from "react"
import { Box } from "@mui/material"
import { ArrowForward } from "@mui/icons-material"
import { POOLS_MAP, PoolName } from "src/constants"
import {
  getChainId,
  formatApr,
  formatBoostedApr,
  formatBNToString,
} from "src/utils"
import usePoolData from "src/hooks/usePoolData"
import useFarmBoostHandler from "src/hooks/BoostFarming/useFarmBoostHandler"

import { CommonWarning } from "../CroWarning"
import Text from "../Text"
import Button from "../Button"
import QuestionHelper from "../QuestionHelper"

interface PoolRemoveViewProps {
  poolName: PoolName
  onClose?: () => void
}

const PoolRemoveView: React.FC<PoolRemoveViewProps> = ({
  poolName,
  onClose,
}) => {
  const chainId = getChainId()
  const pool = POOLS_MAP[poolName]
  const { lpToken } = pool
  const [poolData, , boostData] = usePoolData(poolName)
  const boostFactor = boostData?.boostFactor
    ? parseFloat(formatBNToString(boostData.boostFactor, 18))
    : 1
  const pid = pool.rewardPids[chainId]
  const { onRemoveBoost } = useFarmBoostHandler()

  return (
    <Box>
      <Text mb={3}>Remove boosted APR from:</Text>
      <Box
        display="flex"
        alignItems="center"
        padding="16px"
        gap={1}
        sx={{
          borderRadius: "10px",
          backgroundColor: "#000000",
        }}
      >
        <img src={lpToken.icon} height={24} />
        <Text>{poolName}</Text>
      </Box>
      <Box>
        <Box
          my={3}
          alignItems="center"
          display="flex"
          justifyContent="space-between"
        >
          <Box alignItems="center" display="flex" gap={1}>
            <Text size="small">APR impacted</Text>
            <QuestionHelper text="The estimated APR after removing pool boost from the selected pool." />
          </Box>
          <Box alignItems="center" display="flex" gap={1}>
            <Text size="small">
              {formatBoostedApr(poolData?.apr, poolData?.ferroApr, boostFactor)}
            </Text>
            <ArrowForward fontSize="small" />
            <Text size="small" color="#d9475a">
              {formatApr(poolData?.apr)}
            </Text>
          </Box>
        </Box>
        <CommonWarning content="You will stop enjoying a higher APR in this selected pool. You can still harvest the boosted rewards on the rewards page." />
        <Button
          mt={3}
          fullWidth
          onClick={() => {
            console.log("onRemoveBoost", pid)
            pid &&
              onRemoveBoost(pid).then(() => {
                onClose && onClose()
              })
          }}
        >
          Remove boost
        </Button>
      </Box>
    </Box>
  )
}

export default PoolRemoveView
